function uniqueArray(array, key) {
  if (typeof key === 'string') {
    return [...new Map(array.map((item) => [item[key], item])).values()];
  }
  return [...new Set(array)];
}

export default uniqueArray;
